import * as React from 'react';
import * as I18n from 'i18n-js';
import gql from 'graphql-tag';
import { useUser } from '../user_hooks';
import { experiments } from '../constants';
import { InOtherCartsCardData } from '../rql';
import { isExperimentEnabled } from '../user_context_helpers';
import { useViewTracking } from '../use_tracking';
import { MParticleEventName } from '../elog/mparticle_types';
import { formatExperimentsForEventAttributes } from '../elog/mparticle';

interface IProps {
  listing: InOtherCartsCardData.Fragment;
}

export const InOtherCartsCardFragment = gql`
  fragment InOtherCartsCardData on Listing {
    _id
    id
    otherBuyersWithListingInCartCounts
  }
`;

export function InOtherCartsCardNudge(props: IProps) {
  const user = useUser();

  const { id, otherBuyersWithListingInCartCounts } = props.listing;
  const eligible = !!otherBuyersWithListingInCartCounts &&
    otherBuyersWithListingInCartCounts > 0;

  const mParticleViewData = {
    componentName: 'InOtherCartsCardNudge',
    eventName: MParticleEventName.ComponentView,
    displayStyle: `other_carts:${otherBuyersWithListingInCartCounts}`,
    listingId: id,
    experiments: formatExperimentsForEventAttributes(user, [
      experiments.GRID_OTHER_CARTS_NUDGE,
    ]),
  };

  useViewTracking(mParticleViewData, eligible);

  if (!eligible || !isExperimentEnabled(user, experiments.GRID_OTHER_CARTS_NUDGE)) {
    return null;
  }

  return (
    <div className="grid-card__nudge grid-card__nudge--in-other-carts">
      {I18n.t(
        'commons.listingNudge.inOtherCarts',
        { count: otherBuyersWithListingInCartCounts },
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/in_other_carts_card_nudge.tsx